export default __webpack_public_path__ + "static/media/Steelspirit Armguards.843a7476.jpg";